import styled from "styled-components";
import { Box } from "@mui/material";

export const CMHeadingContainer = styled.div((props) => ({
  alignItems: "center",
  justifyContent: "center",

  "& h3": {
    fontFamily: props.theme.fontFamilies.Jost,
    fontWeight: "normal",
    textAlign: "center",
    [`@media (min-width: 2000px)`]: {
      fontSize: "2.5vh",
    },
  },

  

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
  },
  
}));

export const CMBoxcontainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent:"space-between",

  [`@media${props.theme.breakpoints.lg}`]: {
    height: "auto",
  },
  [`@media${props.theme.breakpoints.xs}`]: {
    height: "auto",
  },

  "& #balanceAC":{
    fontSize:"18px",
    fontWeight:"normal"
  }

}));
export const CMBox = styled(Box)((props) => ({
  textAlign: "center",
  backgroundColor: "#F3FAFC",
  borderRadius: 33,
  height: "auto",
  marginTop: 30,
  paddingLeft: "2%",
  paddingRight: "2%",
  width:"auto",
  "& h3": {
    fontFamily: props.theme.fontFamilies.Jost,
    fontWeight: "normal",
    textAlign: "center",
    paddingTop: "5%",
    paddingLeft: "8%",
    paddingRight: "8%",
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
    },
  },
  [`@media (min-width: 2000px)`]: {
    height: "auto",
  },

  [`@media${props.theme.breakpoints.md}`]: {
   width:"100%",
   paddingLeft:"0px",
   paddingRight:"0px",
  borderRadius: "0px",
  },
 
}));

export const CMFooter = styled.div((props) => ({
  paddingLeft: "3%",
  paddingRight: "3%",
  textAlign: "center",
  marginTop: 20,
  "& p":{
    [`@media (min-width: 2000px)`]: {
    fontSize: "3vh !important",
  },
  },
  [`@media (min-width: 2000px)`]: {
    marginTop: "5vh",
    marginBottom:"5vh"
  },
}));
export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  paddingBottom: "5%",

  "& Button": {
    height: 53,
    width: 204,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));
